module.exports = __webpack_public_path__ + "ps.svg?1b8d03996bc990a274d24d660912fe66";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ps.svg
// module id = 1575
// module chunks = 0